<template>
  <a-menu
    class="hm-web-menu"
    theme="light"
    mode="horizontal"
    :selectedKeys="selectedKeys"
    @click="onMenuSelect"
  >
    <a-menu-item key="social-recruitment">社会招聘</a-menu-item>
    <a-menu-item key="campus-recruitment">校园招聘</a-menu-item>
    <a-menu-item key="hm-style">华盟风采</a-menu-item>
    <a-sub-menu title="关于华盟" popupClassName="hm-web-menu__subMenu">
      <a-menu-item key="introduce">华盟介绍</a-menu-item>
      <a-menu-item key="about">联系我们</a-menu-item>
    </a-sub-menu>
  </a-menu>
</template>

<script>
export default {
  name: 'hmMenu',
  data () {
    return {
      selectedKeys: ['social-recruitment'],
      subMenuActiveKey: ''
    }
  },
  watch: {
    '$route' () {
      this.subMenuActiveKey = ''
      this.initMenu()
    }
  },
  created () {
    this.initMenu()
  },
  methods: {
    initMenu () {
      this.selectedKeys = []
      let key = this.$route.name
      if (key === 'product') {
        this.subMenuActiveKey = this.$route.params.type
      } else {
        this.selectedKeys = [this.$route.name]
      }
    },
    onMenuSelect ({key}) {
      if (!key) return
      if (['video-product', 'video-shop'].includes(key)) {
        this.$bus.$emit('onShowVideo', key)
        return
      }
      console.log('%c点击菜单', 'background-color: green;color: #fff;', key)
      this.selectedKeys = [key]
      this.subMenuActiveKey = ''
      this.$router.push({
        name: key
      })
    },
    onClickMenu (record) {
      const { routeName, key } = record
      console.log('%c点击产品服务菜单', 'background-color: green;color: #fff;', record)
      this.subMenuActiveKey = key
      this.selectedKeys = []
      this.$router.push({
        name: routeName,
        params: { type: key }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.hm-web-menu.ant-menu {
  background-color: #fff;
  height: 64PX;
  line-height: 64PX;
  font-size: 16PX;
  user-select: none;
  .ant-menu-item,
  .ant-menu-submenu-title {
    padding: 0 8PX;
    margin-left: 8PX;
    margin-right: 8PX;
  }
  &.ant-menu-horizontal .ant-menu-item,
  &.ant-menu-horizontal .ant-menu-submenu {
    margin-top: -2PX;
  }
  &.ant-menu-horizontal > .ant-menu-item:hover,
  &.ant-menu-horizontal > .ant-menu-item-selected {
    color: #292F3A;
    font-weight: 600;
  }
}

.hm-web-menu__subMenu-product {
  .ant-menu-item-group {
    float: left;
  }
}

.product-subMenu {
  width: 1040PX;
  height: 320PX;
  &.ant-popover-placement-bottomLeft {
    padding-top: 0;
  }
  .ant-popover-inner-content {
    padding: 0;
  }
  .ant-popover-arrow { display: none; }
  .product-subMenu-content {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .product-subMenu-title {
    padding-left: 14PX;
    font-size: 14PX;
    color: #848D9E;
    line-height: 30PX;
    font-weight: 600;
  }
  .ant-divider {
    margin: 10PX 0 0 0;
    color: #D8DDE6;
  }
  .product-subMenu-wrap {
    padding: 16PX;
    &.product {
      width: 640PX;
    }
    &.service {
      width: 400PX;
      background-color: #F8F9FC;
      .desc {
        color: #292F3A;
      }
    }
  }
  .product-subMenu-item {
    height: 66PX;
    padding: 12PX 16PX;
    margin-top: 16PX;
    border-radius: 6PX;
    transition: all cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;
    cursor: pointer;
    .title {
      font-size: 14PX;
      color: #292F3A;
      line-height: 15PX;
      font-weight: 600;
    }
    .desc {
      margin-top: 7PX;
      font-size: 12PX;
      color: #848D9E;
      line-height: 12PX;
      font-weight: 400;
    }
    &.active,
    &:hover {
      opacity: 0.8;
      background-color: #E8EEF8;
      .title {
        color: #3E77FF;
      }
    }
  }
}
.hm-web-menu{
  /deep/ .ant-menu-submenu-selected{
    color: #292F3A;
    font-weight: bolder;
  }
  /deep/ .ant-menu-submenu-title:hover{
    color: #292F3A;
    font-weight: bolder;
  }
}
</style>
<style lang="less">
.hm-web-menu__subMenu {
  .ant-menu-vertical.ant-menu-sub {
    min-width: auto;
  }
  .ant-menu-vertical .ant-menu-item {
    padding: 0 24PX;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hm-menu/invite-job-index.vue